import { Relationship } from './relationship';
import { IRelationship, IColumnRelationshipInformation } from './interface';

export class RelationshipUtils {
    public static isSame(a: Relationship, b: Relationship): boolean {
        if (a.realName === b.realName) {
            return true;
        }

        const aContent: IRelationship = a.content;
        const bContent: IRelationship = b.content;
        if (aContent.fromTableName !== bContent.fromTableName || aContent.toTableName !== bContent.toTableName) {
            return false;
        }

        const aColumnInfos: IColumnRelationshipInformation[] = aContent.columnRelationshipInformations;
        const bColumnInfos: IColumnRelationshipInformation[] = bContent.columnRelationshipInformations;

        if (aColumnInfos.length !== bColumnInfos.length) {
            return false;
        }
        for (const aColumnInfo of aColumnInfos) {
            let found = false;
            for (const bColumnInfo of bColumnInfos) {
                if (aColumnInfo.fromColumnName === bColumnInfo.fromColumnName
                    && aColumnInfo.toColumnName === bColumnInfo.toColumnName) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                return false;
            }
        }
        return true;
    }

    public static columnsToString(columnInfos: IColumnRelationshipInformation[]): string[] {
        let fromColumns = '';
        let toColumns = '';
        for (const columnInfo of columnInfos) {
            if (fromColumns !== '') {
                fromColumns += ', ';
            }
            fromColumns += columnInfo.fromColumnName;
            if (toColumns !== '') {
                toColumns += ', ';
            }
            toColumns += columnInfo.toColumnName;
        }
        return [fromColumns, toColumns];
    }
}
